import { Input, InputProps } from '@sgi/gravity';
import { useControl } from '../../hooks/useControl';
import { ControlledProps } from '../../types';

export type FormInputProps = Omit<InputProps, ControlledProps>;

export const FormInput = (props: FormInputProps) => {
  const { error, field } = useControl({ name: props.name });
  return <Input {...props} error={error} {...field} />;
};
